import { createStore } from "@stencil/store";

export interface FinderStateStoreTypes {
  savedSearchesCount: number;
  savedVehiclesCount: number;
}

export const finderStoreDefaultData = {
  savedSearchesCount: 0,
  savedVehiclesCount: 0,
};
export const finderStateStore = createStore<FinderStateStoreTypes>(
  finderStoreDefaultData,
);
